import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
@Component({
    template: "",
    standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class UnSubscriber implements OnDestroy {
  _subscription: Subscription = new Subscription();

  protected resetSubscriptions() {
    this._subscription?.unsubscribe();
  }

  addSubscription(sub: Subscription) {
    this._subscription.add(sub);
  }

  set anotherSubscription(sub: Subscription) {
    this._subscription.add(sub);
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}
